import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { SessionComponent } from './session/session.component';
import { FormsModule } from '@angular/forms';

import { SharedComponent } from './shared.component';
import { CreatesessionComponent } from './createsession/createsession.component';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxEditorModule } from 'ngx-editor';



@NgModule({
  declarations: [SessionComponent, SharedComponent, CreatesessionComponent],
  imports: [
    CommonModule,
    SharedRoutingModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxEditorModule,
  ]
})
export class SharedModule { }
